import React, { useEffect } from "react";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";

const StepBreadcrumb = ({ step }) => {
  const navigate = useNavigate();

  let listArray = [
    {
      link: "/book-appointment",
      title: "ثبت اطلاعات",
      active: false,
    },
    {
      link: null,
      title: "تعیین زمان نوبت",
      active: false,
    },
    // {
    //   link: "/confirm-appointment",
    //   title: "تایید اطلاعات",
    //   active: false,
    // },
  ];

  const createlist = () => {
    return listArray.map((item, index) => {
      return {
        ...item,
        active: index <= step,
        link: index <= step ? item.link : "",
      };
    });
  };

  useEffect(() => {
    createlist();
  }, [step]);

  const updatedListArray = createlist();

  return (
    <div className="step-breadcrumb px-2">
      <span>
        {updatedListArray.map((item, index) => (
          <div
            type="button"
            key={index}
            className={
              item.active
                ? "btn btn-link text-decoration-none pe-3 ps-0 step-linear-gradient-color"
                : "btn btn-link text-decoration-none pe-3 ps-0 disabled"
            }
            onClick={() => {
              if (index !== 1) navigate(item.link);
            }}
          >
            {index >= updatedListArray.length - 1 ? (
              <span className="pe-3">{">"}</span>
            ) : (
              ""
            )}
            {item.title}
          </div>
        ))}
      </span>
    </div>
  );
};

export default StepBreadcrumb;
